import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import PostCard from './PostCard';
import { getPostById } from '../services/api';
import useSeo from '../hooks/useSeo';
import { getApiBase } from '../services/runtimeConfig';

const API_BASE = getApiBase();

function getFirstImage(media = []) {
  const list = Array.isArray(media) ? media : [];
  for (const item of list) {
    const url = typeof item === 'string'
      ? item
      : (item && typeof item === 'object' ? (item.url || item.path || '') : '');
    if (!url) continue;
    if (/\.(jpe?g|png|gif|webp)$/i.test(url)) {
      return `${API_BASE}${url}`;
    }
  }
  return '';
}

export default function PostPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useSeo({
    title: post ? `${post.username || 'Anonymous'}'s Post` : 'Post',
    description: post?.content
      ? String(post.content).slice(0, 150)
      : 'View a shared post on TheScandal.',
    path: id ? `/post/${id}` : '/post',
    image: post ? getFirstImage(post.media) : '',
    imageAlt: post ? `${post.username || 'Anonymous'} post preview` : 'Post preview image',
    keywords: ['shared post', 'community update', 'anonymous post'],
  });

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');

    getPostById(id)
      .then((data) => {
        if (cancelled) return;
        setPost(data);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Failed to load post.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return <div className="empty-state"><p>Loading post...</p></div>;
  }

  if (error || !post) {
    return (
      <div className="empty-state">
        <h2>Post not available</h2>
        <p>{error || 'This post could not be found.'}</p>
        <Link to="/" className="btn-primary">Back to feed</Link>
      </div>
    );
  }

  return (
    <section aria-label="Single post view">
      <PostCard post={post} disableCardNavigation defaultExpanded />
    </section>
  );
}
